// Add a loading when steps number are clicked in request form to prevent multiple clicking

(function () {
    var trigger_loading_target = document.querySelector('[data-target-step-loading]');

    if (!trigger_loading_target) {
        return false;
    }

    var trigger_loading_steps = trigger_loading_target.querySelectorAll('[data-trigger-step-loading]');

    for (var indexStep = 0; indexStep < trigger_loading_steps.length; indexStep++) {
        var trigger_loading_step = trigger_loading_steps[indexStep];

        trigger_loading_step.addEventListener('click', function () {
            trigger_loading_target.classList.add('is-step-loading');
        });
    }
}());
